module.exports = __webpack_public_path__ + "images/addAdultPNG_afe09e7.png";